import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '0.25rem 1.5rem',
    borderRadius: 5,
    fontSize: 14,
    fontWeight: 700,
  },

  option: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    justifyContent: 'space-between',
  },

  name: {
    textTransform: 'capitalize',
    '@media (max-width: 1100px)': {
      display: 'none',
    },
  },
}))

export default styles
